<template>
    <div class="my-account">

        <div class="my-account-frame">
            <div role="button" data-toggle="collapse" data-target="#myAccountMenu"  v-if="!isLoggedIn" class="hAcc collapsed" 
                aria-expanded="false"
                :aria-label="myAccountTitle">
                <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="user" class="svg-inline--fa fa-user hAccIcon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336h101.3C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480z"></path></svg>
                <div class="hAccTexts d-none d-lg-inline">
                    <div class="hProfile">{{ myAccountTitle }}</div>
                    <div class="hIdent small">{{ myAccountSubTitle }}</div>
                </div>
                <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" class="svg-inline--fa fa-angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M362.7 203.9l-159.1 144c-6.125 5.469-15.31 5.469-21.44 0L21.29 203.9C14.73 197.1 14.2 187.9 20.1 181.3C26.38 174.4 36.5 174.5 42.73 180.1L192 314.5l149.3-134.4c6.594-5.877 16.69-5.361 22.62 1.188C369.8 187.9 369.3 197.1 362.7 203.9z"></path></svg>
            </div>

            <div role="button" data-toggle="collapse" data-target="#myAccountMenu" v-if="isLoggedIn" class="hAcc collapsed"
                aria-expanded="false"
                :aria-label="myAccountTitle">
                <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="user" class="svg-inline--fa fa-user hAccIcon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336h101.3C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480z"></path></svg>
                <div class="hAccUsername d-none d-lg-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</div>
                <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-down" class="svg-inline--fa fa-angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M362.7 203.9l-159.1 144c-6.125 5.469-15.31 5.469-21.44 0L21.29 203.9C14.73 197.1 14.2 187.9 20.1 181.3C26.38 174.4 36.5 174.5 42.73 180.1L192 314.5l149.3-134.4c6.594-5.877 16.69-5.361 22.62 1.188C369.8 187.9 369.3 197.1 362.7 203.9z"></path></svg>
            </div>
        </div>

        
        <div id="myAccountMenu" class="collapse" ref="collapse" v-if="!isLoggedIn">
            <div class="collapse-inner list-group">
                <a class="btn btn-secondary" data-testing="login-select" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                    <span class="d-inline">{{ $translate("Ceres::Template.login") }}</span>
                </a>
                {{ $translate("Ceres::Template.loginCallToAction") }}
                <a class="register-link" data-testing="register-select" :href="isRegister ? 'javascript:void(0)' : '#registration'" :data-toggle="isRegister ? false : 'modal'"  @click="createRegisterModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.loginRegister')">
                    <span class="d-inline">{{ $translate("Ceres::Template.regRegister") }}</span>
                </a>
                <slot name="global-myAccount-links"></slot>
            </div>
        </div>


        <div id="myAccountMenu" class="collapse" ref="collapse" v-if="isLoggedIn">
            <div class="collapse-inner list-group isLoggedIn">
                <div class="d-inline d-lg-none hAccUsername-link">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</div>
                <div class="myAccount-links">
                    <a :href="$ceres.urls.myAccount" class="list-group-item small">
                        <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="user" class="svg-inline--fa fa-user hAccIcon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336h101.3C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480z"></path></svg> 
                        {{ $translate("Ceres::Template.loginMyAccount") }}
                    </a>
                </div>
                <slot name="global-myAccount-links"></slot>
                <slot name="loggedIn-myAccount-links"></slot>
                <div class="myAccount-links">
                    <a href="#" class="list-group-item small" v-logout><i class="fa fa-sign-out"></i> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
      


    </div>
</template>

<script>
// we replaced ./ with Ceres/components/itemList/  where Ceres is alias of  Ceres\resources\js\src\app
import userLoginHandler from "Ceres/components/customer/login/UserLoginHandler.vue";
import { mapGetters } from "vuex";

export default {
    name: "irri-login-handler",
    extends: userLoginHandler,

    props: {
        myAccountTitle: {
            type: String,
            default: ""
        },
        myAccountSubTitle: {
            type: String,
            default: ""
        } 
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    }

}
</script>
